
(function($){
  $(document).on( 'ready', function(){
    $('.ns-keyfigure').each(function(){
      $(this).find('.ns-keyfigure__tab-right:not(.active)').hide();
    });

    $('.ns-keyfigure__tab-left').on('click tap mouseover',function(){
      var right = $(this).next('.ns-keyfigure__tab-right');
      right.removeClass('fade-in-block');
      right.removeClass('fade-in-block--visible');

      var keyfigureWrapper = $(this).parent().parent();
      keyfigureWrapper.find('.ns-keyfigure__tab-left').not($(this)).removeClass('active');
      keyfigureWrapper.find('.ns-keyfigure__tab-right').not(right).removeClass('active');
      $(this).addClass('active');
      right.addClass('active');

      if($(window).width()< 768){

        right.slideDown(300, 'linear');
        keyfigureWrapper.find('.ns-keyfigure__tab-right').not(right).slideUp(300, 'linear');

      } else {
        // keyfigureWrapper.find('.ns-keyfigure__tab-right').not(right).fadeOut();

        // right.fadeIn();

        keyfigureWrapper.find('.ns-keyfigure__tab-right').not(right).fadeOut(200, 'linear').promise().done(function(){
          setTimeout(function(){
            right.fadeIn(200, 'linear');
           }, 100);
        });
      }
    });
  });
})(jQuery);
